import styled from 'styled-components'

export const Button = styled.button<{ color?: string}>`
  display: inline-block;
  height: 64px;
  background-image: ${({ color }) => (color === 'purple') ? 'linear-gradient(to bottom, #d786ec, #d786ec)'
  : 'linear-gradient(to bottom, #ff9921, #f58238)'};

  box-shadow: 0 6px 10px 0 rgba(224, 134, 39, 0.12), 0 8px 20px 0 rgba(214, 121, 35, 0.12),
    0 8px 40px 0 rgba(223, 123, 32, 0.12), 0 12px 60px 0 rgba(232, 136, 48, 0.12),
    0 16px 80px 0 rgba(227, 129, 40, 0.12);

  padding: 14px 50px;
  border: none;
  border-radius: 32px;

  font-family: Nunito;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 3px;
  text-align: center;
  color: #ffffff;

  box-sizing: border-box;

  :hover, :focus, enabled: {
    background-image: linear-gradient(to bottom, #ff9921, #cf6a29);
    box-shadow: 0 6px 10px 0 rgba(224, 134, 39, 0.12), 0 8px 20px 0 rgba(214, 121, 35, 0.12),
      0 8px 40px 0 rgba(223, 123, 32, 0.12), 0 12px 60px 0 rgba(232, 136, 48, 0.12),
      0 16px 80px 0 rgba(227, 129, 40, 0.12);
  }

  :active {
    background-image: ${({ color }) => (color === 'purple') ? 'linear-gradient(to bottom, #d786ec, #d786ec)'
    : 'linear-gradient(to bottom, #de841a, #f58238)'};
    box-shadow: none;
  }
  
  :disabled {
   opacity: 0.3;
  }
`

export const ButtonSecondary = styled(Button)`
  background-image: none;
  background: white;
  border: 1px solid #FA8D2D;
  padding: 12px 48px;
  color: #FA8D2D;
  box-shadow: none;

  :hover, :focus {
    background-image: none;
    box-shadow: none;
  }

  :active {
    background-image: none;
    background: #F1F1F1;
  }
`

export const ButtonSmall = styled(Button)`
  height: 41px;
  font-size: 16px;
  letter-spacing: 2.4px;
  padding: 6px 21px;
`

export const ButtonSecondarySmall = styled(ButtonSecondary)`
  height: 41px;
  font-size: 16px;
  letter-spacing: 2.4px;
  padding: 6px 21px;
`



// WEBPACK FOOTER //
// ./src/atoms/Button.tsx